import { apiCall, ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { Order } from '../../../interfaces/Order/Order'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'
import axios from 'axios'

// Función para obtener pedidos con filtros, paginación y ordenamiento
export const getOrders = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy: GenericOrderBy<Order>
) => {
  const queryParams = new URLSearchParams()

  // Agregar paginación
  queryParams.append('page', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  // Agregar ordenamiento
  queryParams.append('sortField', orderBy.field.toString())
  queryParams.append('sortDirection', orderBy.direction)

  // Agregar filtros
  filters.forEach(filter => {
    if (filter.value !== undefined && filter.value !== '') {
      queryParams.append(filter.key, filter.value.toString())
    }
  })

  const url = `${ApiConfig.OrderApi}?${queryParams.toString()}`
  return apiCall('GET', url)
}

// Función para crear orden de trabajo
export const createWorkOrder = (workOrderData: {
  typeWorkOrderId: number
  workOrderDetails: { orderId: number }[]
  warehouseId: number
}) => {
  return apiCall('POST', ApiConfig.WorkOrderApi, workOrderData)
}

// Función para actualizar pedido
export const updateOrder = (orderId: number, orderData: Partial<Order>) => {
  return apiCall('PUT', `${ApiConfig.OrderApi}/${orderId}`, orderData)
}

// Función para eliminar pedido
export const deleteOrder = (orderId: number) => {
  return apiCall('DELETE', `${ApiConfig.OrderApi}/${orderId}`)
}

// Función para obtener detalles de un pedido
export const getOrderDetails = (orderId: number) => {
  return apiCall('GET', `${ApiConfig.OrderApi}/${orderId}`)
}

// ==========================================
// NUEVAS FUNCIONES DE API
// ==========================================

// Función para cargar archivo Excel de pedidos (Filtro Externo)
export const uploadOrderFile = (file: File, warehouseId: number) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('warehouseId', `${warehouseId}`)

  const axiosInstance = axios.create({
    baseURL: ApiConfig.ProcessApi,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return axiosInstance.post(`/WorkOrderUploadFile`, formData, {
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log(`Upload Progress: ${percentCompleted}%`)
      }
    }
  })
}

// Función para buscar órdenes de trabajo (para autocompletador)
export const searchWorkOrders = (searchTerm: string) => {
  return apiCall('GET', `${ApiConfig.WorkOrderApi}/search/${searchTerm}`)
}

// Función para incorporar pedidos a orden de trabajo existente
export const incorporateOrdersToWorkOrder = (workOrderData: {
  workOrderId: number
  workOrderAddDetails: { orderId: number }[]
}) => {
  return apiCall('PUT', ApiConfig.WorkOrderApi, workOrderData)
}

// Función para cargar archivo de pedidos internos
export const uploadInternalOrderFile = (
  file: File,
  orderData: {
    courierDeliveryDate: string
    courierId: number
    courierServiceId: number
    neighborhoodId: number
    stateId: number
    cityId: number
    userId: number
    rtv: boolean
    comments: string
    orderOriginId: number
  }
) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('courierDeliveryDate', orderData.courierDeliveryDate)
  formData.append('courierId', `${orderData.courierId}`)
  formData.append('courierServiceId', `${orderData.courierServiceId}`)
  formData.append('stateId', `${orderData.stateId}`)
  formData.append('cityId', `${orderData.cityId}`)
  formData.append('neighborhoodId', `${orderData.neighborhoodId}`)
  formData.append('userId', `${orderData.userId}`)
  formData.append('rtv', `${orderData.rtv}`)
  formData.append('comments', orderData.comments)
  formData.append('orderOriginId', `${orderData.orderOriginId}`)

  const axiosInstance = axios.create({
    baseURL: ApiConfig.ProcessApi,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return axiosInstance.post(`/InternalOrderUploadFile`, formData, {
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log(`Upload Progress: ${percentCompleted}%`)
      }
    }
  })
}

// Función para cancelar un pedido individual
export const cancelSingleOrder = (orderId: number) => {
  const url = `${ApiConfig.OrderApi}/OrderCancellationRequest/${orderId}`
  return axios.patch(url)
}

// Función para cancelar múltiples pedidos
export const cancelMultipleOrders = (orderIds: number[]) => {
  const url = `${ApiConfig.OrderApi}/OrdersCancellationRequest`
  return axios.post(url, { orderIds })
}

// Función para descargar plantilla de archivo Excel
export const downloadTemplate = (templateName: string) => {
  return apiCall(
    'GET',
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateName}`,
    {
      responseType: 'blob'
    }
  )
}
